<template>
  <l-map v-if="markers && markers.length" 
    ref="map"
    :bounds="bounds" 
    :center="simple.center" 
    :zoom="simple.zoom"
    style="height: 100%" 
    @ready="onMapReady"
  >
    <l-tile-layer :url="simple.url" :attribution="simple.attribution" :subdomains="simple.subdomains"
      :max-zoom="simple.maxZoom"></l-tile-layer>

    <l-control position="topleft" v-if="isFullscreen">
  <div class="leaflet-bar custom-minimize-control">
    <a 
      class="leaflet-control-zoom-out" 
      href="#" 
      title="Minimize Map"
      role="button"
      aria-label="Minimize Map"
      @click.prevent="onMinimize"
      style="width: 32px; height: 32px;"
    >
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 24 24" 
        stroke="currentColor"  
        stroke-width="2" 
        stroke-linecap="round" 
        stroke-linejoin="round"
        fill="none" 
        class="w-6 h-6 p-0 text-gray-700" 
        style="margin-top: 5px; display: block; margin-left: auto; margin-right: auto;"
      >
        <!-- Top-right arrow pointing inward -->
        <path d="M19 5l-5 5m0 0h5m-5 0V5"/>

        <!-- Top-left arrow pointing inward -->
        <path d="M5 5l5 5m0 0H5m5 0V5"/>

        <!-- Bottom-left arrow pointing inward -->
        <path d="M5 19l5-5m0 0H5m5 0v5"/>

        <!-- Bottom-right arrow pointing inward -->
        <path d="M19 19l-5-5m0 0h5m-5 0v5"/>
      </svg>
    </a>
  </div>
</l-control>

    <l-marker v-for="(item, index) in markers" :key="index" :lat-lng="item.latLng"
      @click="() => innerClick(item.siteId)">
      <l-tooltip>
        <div>
          {{ item.siteName }}
        </div>
      </l-tooltip>
      <l-icon :icon-size="dynamicSize" :icon-anchor="dynamicAnchor"
        :icon-url="item.siteIcon === 'street' ? iconStreet : icon" />
    </l-marker>
  </l-map>
  <div v-else class="w-full h-full flex items-center justify-center text-gray-500">
    <p>Loading map data...</p>
  </div>
</template>
<script>
import { Tooltip } from "bootstrap/dist/js/bootstrap.esm.min.js";
import "leaflet/dist/leaflet.css";
import { latLngBounds } from "leaflet";
import {
  LMap,
  LMarker,
  LTileLayer,
  LTooltip,
  LIcon,
  LControl,
} from "@vue-leaflet/vue-leaflet";
export default {
  props: {
    markers: {
      type: Array,
      default: () => [],
    },
    isFullscreen: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    LIcon,
    LControl
  },
  watch: {},
  computed: {
    dynamicSize() {
      return [this.iconSize, this.iconSize];
    },
    dynamicAnchor() {
      return [this.iconSize / 2, this.iconSize];
    },
  },
  data() {
    return {
      listMarker: [],
      iconSize: 38,
      icon: require("../../../assets/images/icon/marker-facade.png"),
      iconStreet: require("../../../assets/images/icon/marker-street.png"),
      bounds: latLngBounds(
        { lat: 2.9284, lng: 101.68424 },
        { lat: 2.928236, lng: 101.48424 }
      ),
      mapReady: true,
      simple: {
        url: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
        subdomains: 'abcd',
        zoom: 15,
        minZoom: 3,
        maxZoom: 20,
        center: [2.928236, 101.68424],
        marker: [3.140853, 101.693207],
      },
    };
  },
  methods: {
    onMinimize() {
      console.log("Map Minimize button clicked, emitting 'on-minimize'");
      this.$emit("on-minimize");
    },
    onMapReady(map) {
      // 🚀 FIX 2: Ensure the conditional check is robust before calling map methods
      if (this.markers && this.markers.length > 0) {
        const latLngs = this.markers.map((m) => [m.SiteLat, m.SiteLong]);
        const bounds = latLngBounds(latLngs);

        this.bounds = bounds;

        // Fit bounds (this will adjust center and zoom automatically)
        this.$nextTick(() => {
          map.fitBounds(bounds);
        });
      }
      // This line now works because Tooltip is imported.
      new Tooltip(document.body, {
        selector: "[data-bs-toggle='tooltip']",
      });
    },
    innerClick(id) {
      this.$router.push("/V2/clusterpage?id=" + id);
    },
    innerClick(id) {
      this.$router.push("/V2/clusterpage?id=" + id);
    },
  },
};
</script>
